export default "__VITE_ASSET__TcI$_bUh__"